import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
    notifications: []
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications(state, action: PayloadAction<any>) {
      state.notifications = action.payload
    },
    getNotifications: (state) => {
      return state.notifications // Reset user details
    }
  }
});

export const { setNotifications, getNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;
